import { IQuestionOptionImage } from "../interfaces/IDigitalAdviceData";

export const getOptionImages = (option): IQuestionOptionImage => {
    return (
        (option &&
            option.questionOptionImage &&
            option.questionOptionImage.length &&
            option.questionOptionImage[0]) ||
        {}
    );
};

export const createRange = (start: number, end: number): Array<number> => {
    const res = [];
    for (let i = start; i <= end; i++) {
        res.push(i);
    }
    return res;
};

export const convertBase64toBlob = (linkSource: string): Blob => {
    const byteCharacters = atob(linkSource.split(",")[1]);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], {
        type: "application/pdf"
    });
};
